<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import BuildingDetail from '../../../../../buildings/components/BuildingDetail.vue'
import { BuildingID } from '../../../../../buildings/models/building'

definePage({
    props: true,
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})

const {
  id,
} = defineProps<{
    id: BuildingID
}>()
</script>

<template>
  <BuildingDetail
    :id="id"
  />
</template>